import { connect } from 'react-redux';

import {
  paymentFailed,
  submitCres,
  submitPares,
} from 'src/store/payment/actions';

import { selectCurrentPopup } from 'src/store/popup/selectors';
import { resetPopupState } from 'src/store/popup/slice';
import { getIsMobile } from 'src/store/view/selectors';
import { select3dsData } from '../../store/payment/selectors';

import Payment3dsPopup from './Payment3dsPopup';

const mapStateToProps = (state) => ({
  data: select3dsData(state),
  isOpened: selectCurrentPopup(state) === '3ds',
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = {
  submitPares,
  submitCres,
  closePopup: resetPopupState,
  onFail: paymentFailed,
};

export default connect(mapStateToProps, mapDispatchToProps)(Payment3dsPopup);
